import { CoreTypes } from 'common-cloudstudio';

export module ApolusTypes {

  export const enum ApolusMasterEntityType {
    Unknown = 0, 
    Clients = 1, 
    Contracts = 2, 
    Geocoding_Addresses = 3, 
    Rates = 4, 
    Sectors = 5, 
    ExtendedClients = 9001, 
    ExtendedContracts = 9002, 
    MassExtendedClients = 99001
  }

  export const enum ApolusMenuHierarchyItem {
    Unknown = 0, 
    Clients = 1, 
    Contracts = 2, 
    Geocoding_Addresses = 3, 
    Rates = 4, 
    Sectors = 5, 
    Dashboard = 6, 
    Maps = 7, 
    Reports = 8, 
    Users = 9, 
    Actions = 10, 
    ExtendedClients = 9001, 
    ExtendedContracts = 9002
  }

  export class ApolusCommonLiterals {
    Actions: string;
    BatchClients: string;
    BatchContracts: string;
    Clients: string;
    ClientSuccessMessage: string;
    Connectivity: string;
    Contracts: string;
    ContractNumber: string;
    ContractSuccessMessage: string;
    ContractTitle: string;
    ContractValidationMessage: string;
    Dashboard: string;
    Events: string;
    EventType: string;
    Geocoding_Addresses: string;
    GlobalConsumptions: string;
    HideAddress: string;
    HideElementMessage: string;
    HideRate: string;
    HideSector: string;
    HideSectorMessage: string;
    MajorAccounts: string;
    Maps: string;
    NewClient: string;
    NewContract: string;
    Locality: string;
    OnlineMeters: string;
    Percentage: string;
    Quantity: string;
    Rates: string;
    RateTitle: string;
    ReportedDevices: string;
    Reports: string;
    Sectors: string;
    SmartMetering: string;
    Users: string;
    UserNumber: string;
    TotalMeterPark: string;
  }

  export class ApolusConnectivityTable {
    Date: CoreTypes.DateDT;
    Percentage: number;
    Quantity: number;
  }

  export class ApolusEventsTable {
    AlarmDescription: string;
    Percentage: number;
    Quantity: number;
  }

  export class BulkClientCreation {
    Client: Client[];
    Errors: ClientCreationError[];
  }

  export class BulkClientExtendedCreation {
    Client: ClientExtended[];
    Errors: ClientExtendedCreationError[];
  }

  export class BulkContractCreation {
    Contract: Contract[];
    Errors: ContractCreationError[];
  }

  export class BulkContractExtendedCreation {
    ContractExtended: ContractExtended[];
    Errors: ContractExtendedCreationError[];
  }

  export class BulkGeocodingAddressCreation {
    Errors: GeocodingAddressCreationError[];
    GeocodingAddress: GeocodingAddress[];
  }

  export class BulkRateCreation {
    Errors: RateCreationError[];
    Rate: Rate[];
  }

  export class BulkSectorCreation {
    Errors: SectorCreationError[];
    Sector: Sector[];
  }

  export class Client {
    AddressID: number;
    ClientID: number;
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    Email: string;
    Enabled: boolean;
    ExternalID: string;
    FacilityID: number;
    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    UniqueID: number;
    UpdateSequenceNumber: number;
  }

  export class ClientCreationError {
    Client: Client;
    ErrorMessage: string;
  }

  export class ClientExtended {
    Address: GeocodingAddress;
    Contract: Contract;
    ContractID: number;
    Rate: Rate;
    RateID: number;
    Sector: Sector;
    SectorID: number;
    AddressID: number;
    ClientID: number;
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    Email: string;
    Enabled: boolean;
    ExternalID: string;
    FacilityID: number;
    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    UniqueID: number;
    UpdateSequenceNumber: number;
  }

  export class ClientExtendedCreationError {
    Client: ClientExtended;
    ErrorMessage: string;
  }

  export class ClientMassExtended {
    Address: GeocodingAddress;
    Contract: ContractExtended[];
    AddressID: number;
    ClientID: number;
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    Email: string;
    Enabled: boolean;
    ExternalID: string;
    FacilityID: number;
    FirstName: string;
    LastName: string;
    PhoneNumber: string;
    UniqueID: number;
    UpdateSequenceNumber: number;
  }

  export class Contract {
    AddressID: number;
    ClientID: number;
    ContractID: number;
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    DeviceID: number;
    Enabled: boolean;
    ExternalID: string;
    FacilityID: number;
    RateID: number;
    SectorID: number;
  }

  export class ContractCreationError {
    Contract: Contract;
    ErrorMessage: string;
  }

  export class ContractExtended {
    Address: GeocodingAddress;
    Rate: Rate;
    Sector: Sector;
    AddressID: number;
    ClientID: number;
    ContractID: number;
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    DeviceID: number;
    Enabled: boolean;
    ExternalID: string;
    FacilityID: number;
    RateID: number;
    SectorID: number;
  }

  export class ContractExtendedCreationError {
    ContractExtended: ContractExtended;
    ErrorMessage: string;
  }

  export class Dashboard {
    ConnectivityHistory: CoreTypes.XYChartWidgetData;
    ConnectivityTable: ApolusConnectivityTable[];
    DeviceSummary: DashboardDeviceSummary;
    Events: CoreTypes.PieChartSliceData[];
    EventsTable: ApolusEventsTable[];
    GlobalConsumption: CoreTypes.XYChartWidgetData;
  }

  export class DashboardDeviceSummary {
    OnlineDevices: number;
    TotalDevices: number;
    WithAlarmDevices: number;
  }

  export class GeocodingAddress {
    AddressID: number;
    AdminArea2ID: number;
    ApartmentBuilding: string;
    ObservationsLine1: string;
    ObservationsLine2: string;
    ObservationsLine3: string;
    StreetName: string;
    StreetNumber: string;
    ZipCode: string;
  }

  export class GeocodingAddressCreationError {
    ErrorMessage: string;
    GeocodingAddress: GeocodingAddress;
  }

  export class Rate {
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    Description: string;
    Enabled: boolean;
    RateID: number;
  }

  export class RateCreationError {
    ErrorMessage: string;
    Rate: Rate;
  }

  export class ResolvedGeocodingAddress {
    Addresses: CoreTypes.GeocodingAddress[];
    AddressText: string;
  }

  export class Sector {
    CreatedByAccountID: number;
    DateTimeCreated: CoreTypes.DateTimeDT;
    DateTimeDeleted: CoreTypes.DateTimeDT;
    DateTimeUpdated: CoreTypes.DateTimeDT;
    DeletedByAccountID: number | null;
    Description: string;
    Enabled: boolean;
    SectorID: number;
  }

  export class SectorCreationError {
    ErrorMessage: string;
    Sector: Sector;
  }

  export class UserDashboard {
    Data: UserDashboardData;
    EventsTable: CoreTypes.HtmlWidgetData;
    HistoryConsumption: CoreTypes.HtmlWidgetData;
    RecentConsumption: CoreTypes.XYChartWidgetData;
  }

  export class UserDashboardData {
    AddressID: number;
    AdminArea2ID: number;
    ApartmentBuilding: string;
    ClientExternalID: string;
    ClientID: number;
    ContractExternalID: string;
    ContractID: number;
    Device: CoreTypes.Device;
    FacilityID: number;
    FirstName: string;
    LastName: string;
    ObservationsLine1: string;
    ObservationsLine2: string;
    ObservationsLine3: string;
    RateDescription: string;
    RateID: number;
    SectorDescription: string;
    SectorID: number;
    StreetName: string;
    StreetNumber: string;
    UniqueID: number;
    ZipCode: string;
  }

}
